(function() {
  window.LoamLabsVariantManager = {
    variants: [],
    variantsMap: {},
    isFetching: false,
    hasAllVariants: false,

    async init(productHandle) {
      if (!window.storefrontToken) {
        console.error("Storefront API token missing");
        return;
      }
      this.isFetching = true;
      let hasNextPage = true;
      let cursor = null;
      let allVariants = [];

      while (hasNextPage) {
        const query = `
          query getVariants($handle: String!, $cursor: String) {
            product(handle: $handle) {
              variants(first: 250, after: $cursor) {
                pageInfo { hasNextPage, endCursor }
                nodes {
                  id
                  title
                  availableForSale
                  quantityAvailable
                  price { amount }
                  selectedOptions { name value }
                }
              }
            }
          }
        `;
        const response = await fetch('/api/2024-01/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': window.storefrontToken
          },
          body: JSON.stringify({
            query,
            variables: { handle: productHandle, cursor }
          })
        });

        const data = await response.json();
        const variants = data?.data?.product?.variants;
        if (!variants) break;

        allVariants.push(...variants.nodes);
        hasNextPage = variants.pageInfo.hasNextPage;
        cursor = variants.pageInfo.endCursor;
      }

      this.variants = allVariants.map(v => {
        const id = parseInt(v.id.split('/').pop());
        return {
          id,
          title: v.title,
          available: v.availableForSale,
          price: Math.round(parseFloat(v.price.amount) * 100),
          inventory_quantity: v.quantityAvailable || 0,
          inventory_policy: 'continue', // Safe fallback since Vercel sync manages this
          lead_time_days: window.llProductLeadTime || 99, 
          selectedOptions: v.selectedOptions
        };
      });

      this.variants.forEach(v => {
        this.variantsMap[v.id] = v;
      });

      this.hasAllVariants = true;
      this.isFetching = false;
      document.dispatchEvent(new CustomEvent('ll-variants-loaded', { detail: this.variants }));

      // Enable/disable swatches dynamically based on storefront variants
      this.updateSwatchesAvailability();
      document.querySelectorAll('fieldset.product-form__input input').forEach(input => {
        input.addEventListener('change', () => this.updateSwatchesAvailability());
      });

      // Repair UI for deep links to variants > 250
      const urlParams = new URLSearchParams(window.location.search);
      const urlVariantId = parseInt(urlParams.get('variant'));
      if (urlVariantId && this.variantsMap[urlVariantId]) {
        const variant = this.variantsMap[urlVariantId];
        const priceEls = document.querySelectorAll('.price-item--regular');
        priceEls.forEach(el => el.innerHTML = '$' + (variant.price / 100).toFixed(2));
        const formInputs = document.querySelectorAll('.product-variant-id, input[name="id"]');
        formInputs.forEach(input => input.value = variant.id);
        // Force unhide price if it was hidden
        document.querySelectorAll('.price').forEach(p => p.classList.remove('price--sold-out'));
      }
    },

    getVariantByOptions(optionsArray) {
      return this.variants.find(v => {
        return v.selectedOptions.every(so => optionsArray.includes(so.value));
      });
    },

    updateSwatchesAvailability() {
      const fieldsets = Array.from(document.querySelectorAll('fieldset.product-form__input'));
      if (!fieldsets.length) return;

      const selectedOptions = fieldsets.map(fieldset => {
        const checkedInput = fieldset.querySelector('input:checked');
        return checkedInput ? checkedInput.value : null;
      }).filter(Boolean);

      fieldsets.forEach((fieldset, groupIndex) => {
        const inputs = Array.from(fieldset.querySelectorAll('input'));
        inputs.forEach(input => {
          const value = input.value;
          const tempSelected = [...selectedOptions];
          tempSelected[groupIndex] = value;

          const isAvailable = this.variants.some(v => {
            if (!v.available) return false;
            return tempSelected.every(selVal => {
              return v.selectedOptions.some(so => so.value === selVal);
            });
          });

          const label = fieldset.querySelector(`label[for="${input.id}"]`);
          if (isAvailable) {
            input.classList.remove('visually-disabled', 'disabled');
            input.removeAttribute('disabled');
            if (label) {
              label.classList.remove('visually-disabled', 'disabled');
            }
          } else {
            input.classList.add('visually-disabled');
            if (label) {
              label.classList.add('visually-disabled');
            }
          }
        });
      });
    }
  };
})();
